import { createSelector } from '@reduxjs/toolkit';

export const selectCompanyList = (entities) => entities.companies?.list;

export const selectCompanyNameById = createSelector(
  [selectCompanyList, (entities, companyId) => companyId],
  (companies, companyId) => companies?.find((company) => company.id === companyId)?.name || '',
);
